"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaypalShippingTotal = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function getPaypalShippingTotal() {
    const { selected_shipping: selectedShipping } = (0, checkout_frontend_library_1.getShipping)();
    const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
    return {
        currency_code: currencyCode,
        value: (0, src_1.getValueByCurrency)((selectedShipping === null || selectedShipping === void 0 ? void 0 : selectedShipping.amount) || 0, currencyCode)
    };
}
exports.getPaypalShippingTotal = getPaypalShippingTotal;
